// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Ki05","right":"styles_right__Qav54"};